export default {
  support: {
    support: 'Support',
    requestFeature: 'Request a Feature',
    reportBug: 'Report a Bug',
    topic: 'Topic',
    description: 'Description',
    addScreenshot: 'Add a Screenshot (Optional)',
    towOrder: 'Tow Order',
    dispatch: 'Dispatch',
    thankYouForYourFeedback: 'Thank you for your feedback!',
    weAppreciateYourPartnership: 'We appreciate your partnership',
    couldNotSubmitRequest: 'Unfortunately, we could not submit your request.',
    submit: 'Submit'
  },
};
